import {
  BooleanInput,
  Create,
  required,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { CoronerAddressInputs, coronerAddressTransform } from './CoronerAddressInputs';

export const CoronersCreate = () => (
  <Create transform={coronerAddressTransform}>
    <SimpleForm>
      <TextInput source="id" label="OCC ID" validate={[required()]} helperText="Government dropdown id (e.g. 3367)" />
      <TextInput source="name" validate={[required()]} fullWidth />
      <CoronerAddressInputs />
      <BooleanInput source="active" defaultValue={true} />
    </SimpleForm>
  </Create>
);
